import { ModalWindow } from './ModalWindow';
import { Config, ExportData } from '../types';
import { addMessageListener, removeMessageListener } from "../utils/message";

export class EmbedEditor {
    private modalWindow: ModalWindow;
    private config: Config;
    private url: string = import.meta.env.VITE_EDITOR_URL || 'https://stage.postnitro.ai';
    private callback: (data: ExportData) => void;
    private carouselId: string | null = null;

    constructor(config: Config) {
        this.modalWindow = new ModalWindow(this.url, config, () => {
            this.destroy();
        });
        this.config = config;
        this.handleMessage = this.handleMessage.bind(this);
        // addMessageListener(this.handleMessage);
        this.callback = () => { };
        this.carouselId = null;
    }

    createDesign(callback: (data: ExportData) => void) {
        this.carouselId = null;
        addMessageListener(this.handleMessage);

        this.modalWindow.open(`${this.url}/partnership?apiKey=${this.config.apiKey}`);

        // You can use callback to get the data from the iframe editor.
        this.callback = callback;

    }

    editDesign(id: string, callback: (data: ExportData) => void) {
        this.carouselId = id;
        addMessageListener(this.handleMessage);

        this.modalWindow.open(`${this.url}/partnership?carouselId=${id}&apiKey=${this.config.apiKey}`);

        // You can use callback to get the data from the iframe editor.
        this.callback = callback;
    }

    // Method to handle incoming messages:
    private handleMessage(event: MessageEvent) {
        if (event.data.type === 'postnitro-embed-initialized') {
            console.debug("Event: postnitro-embed-initialized (Embed)")
            const iframe = this.modalWindow.getIframeInstance()
            const origin = window.location.origin;

            if (iframe) {
                iframe.contentWindow?.postMessage({
                    type: 'postnitro-config',
                    data: {
                        apiKey: this.config.apiKey,
                        origin: origin,
                        partner: this.config.defaultHeadshot || undefined
                    }
                },
                    this.url
                )
            }
        }

        // console.log('Incoming message', event.data);

        if (event.data.type === 'postnitro-embed-verified') {
            console.debug("Event: postnitro-embed-verified (Embed)")
            // Remove loader
            this.modalWindow.hideLoader()

            // Show the iframe
            this.modalWindow.showIframe()
        }

        if (event.data.type === 'sign-in') {
            const url = event.data.url;

            // open new window popup to sign in
            const dualScreenLeft = window.screenLeft ?? window.screenX;
            const dualScreenTop = window.screenTop ?? window.screenY;

            const width =
                window.innerWidth ?? document.documentElement.clientWidth ?? screen.width;

            const height =
                window.innerHeight ??
                document.documentElement.clientHeight ??
                screen.height;

            const systemZoom = width / window.screen.availWidth;

            const left = (width - 500) / 2 / systemZoom + dualScreenLeft;
            const top = (height - 550) / 2 / systemZoom + dualScreenTop;

            const newWindow = window.open(
                this.url + '/googleSignIn',
                'Sign in with PostNitro',
                `width=${500 / systemZoom},height=${550 / systemZoom
                },top=${top},left=${left}`
            );

            if (newWindow) {
                const checkWindowClosed = setInterval(() => {

                    if (newWindow.closed) {
                        clearInterval(checkWindowClosed);
                        let url = `${this.url}/partnership?apiKey=${this.config.apiKey}`;

                        if (this.carouselId) {
                            url = `${this.url}/partnership?carouselId=${this.carouselId}&apiKey=${this.config.apiKey}`;
                        }

                        this.modalWindow.refresh(url);
                    }
                }, 500)

                newWindow.focus();
            }
        }

        if (event.data.type === 'editor-complete') {
            // Close the modal window and handle the data:
            this.modalWindow.close();

            // destroy the listener
            this.destroy()

            const data = event.data.data as ExportData

            this.callback(data);
        }

        if (event.data.type === 'refresh') {
            console.debug("Event: refresh (Embed)")
            console.log('event.data.url', event.data)
            this.modalWindow.refresh(event.data.url);
        }
    }

    // Don't forget to remove listener when you're done or the object is deconstructed to prevent memory leaks:
    public destroy() {
        removeMessageListener(this.handleMessage);
    }

}
